import { enumeration } from '@dazn/peng-html5-tools-utils';
var PlaybackState = enumeration([
    /**
     * The manifest has been parsed and the first segments are being downloaded and appended.
     */
    'BUFFERING',
    /**
     * The player instance is no longer needed and can be released from memory.
     */
    'DESTROYED',
    /**
     * A VOD asset has reached its duration, but the session is still alive and the asset may be
     * replayed.
     */
    'ENDED',
    /**
     * A fatal error has occurred and playback cannot continue. The player has been unloaded and is
     * ready to receive the next asset.
     */
    'ERRORED',
    /**
     * An asset ID has been requested, and the player is fetching the source list and metadata
     * needed to play the asset.
     */
    'FETCHING',
    /**
     * The manifest has successfully downloaded been parsed.
     */
    'LOADED',
    /**
     * The manifest is being downloaded or parsed.
     */
    'LOADING',
    /**
     * Playback is paused.
     */
    'PAUSED',
    /**
     * Playback is in progress.
     */
    'PLAYING',
    /**
     * Playback has been interrupted by a stall. Typically this is due to buffer starvation but may
     * be caused by other factors.
     */
    'REBUFFERING',
    /**
     * A manifest failover was requested while a session is in progress. The session shall remain
     * alive but the media pipeline will be reset.
     */
    'RESETTING',
    /**
     * The player has been created or unloaded and is ready to receive an asset.
     */
    'UNLOADED',
]);
export { PlaybackState };
//# sourceMappingURL=PlaybackState.js.map